import toast from 'siiimple-toast'

$(function () {

    var customToast = toast.setOptions({
        container: 'body',
        class: 'siiimpleToast',
        position: 'bottom|right',
        margin: 15,
        delay: 0,
        duration: 3000,
        style: {},
    });

    $(window).on( "form-submit", function( event, params, form ) {
        //console.log(params);
        //console.log(form);

    });

    $(window).on( "form-submit--footer-subscription-form", function( event, params, form ) {
        $('.join-newsletter-container').hide();
        $(form).parent().html(params.respond);
    });

    $(window).on( "form-submit--contact-form", function( event, params, form ) {
        $(form).parent().append(params.respond);
        apa("Submitted_enquiry_form")
    });

    $(window).on( "form-submit--vip-request-form", function( event, params, form ) {
        $(form).parent().html(params.respond);
    });

    $(window).on( "form-submit--share-quote-form", function( event, params, form ) {
        $(form).find('input[type=email]').val('');
        customToast.success(params.respond, { duration: 5000});
    });

    $(window).on( "form-submit--share-retail-quote-form", function( event, params, form ) {
        $(form).find('input[type=email]').val('');
        customToast.success(params.respond, { duration: 5000});
    });


    $(window).on( "form-submit--request-sample-form", function( event, params, form ) {
        $('.product-favourites-list').hide();
        $(form).parent().html(params.respond);
    });

    $(window).on( "form-submit--enquiry-form", function( event, params, form ) {
        $(form).parent().html(params.respond);
    });

    $(window).on( "form-submit--book-measure-form", function( event, params, form ) {
        $(form).parent().html(params.respond);
    });




    $(window).on( "form-submit--register-form", function( event, params, form ) {
        fakeButton($(form));

        if(params.respond == '1'){
            location.href = "/Security/login/";
        }else{
            $(form).parent().html(params.respond);
        }
    });


    $(document).on('click', '.btn--submit', function (e) {
       /* e.preventDefault();
        console.log('hi from Edward');

        let $form = $(this).closest('form');

        if($form.hasClass('form--validate')){
            $form.find('.form-control[required]').each(function () {
                if($(this).val()){
                    let name = $(this).parent().find('.message.required').remove();
                }else{
                    let name = $(this).parent().find('label').html();
                    if(!name){
                        name = 'Input'
                    }
                    $(this).parent().append(`<span class="message required">"${name}" is required</span>`)
                }

            });
        }else{
            $form.trigger('submit');
        }*/
    });

    $('form.form--ajax').each(function () {
        fakeButton($(this));
    });

    function fakeButton($form){
        $form.find('input[type=submit]').each(function () {
            var text = $(this).attr('value');
            var btnClass = $(this).attr('class');
            btnClass = btnClass.replace('g-recaptcha', '');
            btnClass = btnClass.replace('action', '');
            btnClass = btnClass.trim();
            if(btnClass.length == 0){
                btnClass = 'btn btn-primary';
            }else{
                btnClass += ' btn ';
            }
            $(this).after(`<button class="btn--submit btn ${btnClass}">${text}</button>`);
            $(this).hide();
        });
    }



    $(document).on('submit', 'form.form--ajax', function (e) {
        e.preventDefault();
        var $form = $(this);
        var url = $form.attr('action');
        var siteKeyDiv = $form.find('.g-recaptcha[data-sitekey]');
        var action = $form.find('.g-recaptcha[data-action]').attr('data-action');
        var $respondInput = $form.find(".g-recaptcha-response");
        var id = $form.attr('custom-id') ? $form.attr('custom-id') : $form.attr('id');
        if(siteKeyDiv){
            var siteKey = siteKeyDiv.attr('data-sitekey');
            grecaptcha.execute(siteKey, {action: action}).then((token) => {
                $respondInput.val(token);
                var data = $form.serialize();
                $('.loading-frame').show();
                $.post(url, data, function (respond) {
                    $('.loading-frame').hide();
                    $(window).trigger( "form-submit", [{id: id, data: $form.serializeArray(), respond: respond}, $form]);
                    $(window).trigger( "form-submit--" + id, [{id: id, data: $form.serializeArray(), respond: respond}, $form]);
                });
            });
        }else{
            var data = $form.serialize();
            $('.loading-frame').show();
            $.post(url, data, function (respond) {
                $('.loading-frame').hide();
                $(window).trigger( "form-submit", [{id: id, data: $form.serializeArray(), respond: respond}, $form]);
                $(window).trigger( "form-submit--" + id, [{id: id, data: $form.serializeArray(), respond: respond}, $form]);
            });
        }
    });

    if($('.assign-form').length){
        $('.assign-form .btn-toolbar').append(`<button class='btn btn-light btn--cancel ms-4'>Cancel</button>`);

        $('.assign-form .assign-form__customer-email').change(function () {
            var emailValue = $(this).val();
            var mailFormat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

            if(emailValue.match(mailFormat)) {
                $('.assign-form .btn--save').attr('disabled', 'disabled');
                $('.assign-form').addClass('loading');
                $.post('/manager/checkEmail/', {email: emailValue}, function (result) {
                    $('.assign-form .btn--save').removeAttr('disabled');
                    $('.assign-form').removeClass('loading');
                    if(result == '1'){
                        $('.button-container').show();
                        $('.btn-toolbar').hide();
                        $('.assign-form__customer-info').slideUp();
                    }else{
                        $('.button-container').hide();
                        $('.btn-toolbar').show();
                        $('.assign-form__customer-info').slideDown();
                    }
                })
            }
        });

        $('.assign-form .btn--cancel').click(function (e) {
            e.preventDefault();
            $('.assign-form__customer-info').slideUp();
            $('.button-container').show();
            $('.btn-toolbar').hide();
            $('.assign-form .assign-form__customer-email').val('');
        });

    }


});

